import {Component, Input} from '@angular/core';
import {BaseResultComponent} from '../../base-result/base-result.component';
import {AssetRisk} from '../../../../class/result/safeguard/asset-risk';
import {NbWindowService} from '@nebular/theme';

@Component({
  selector: 'app-asset-risk',
  templateUrl: './asset-risk.component.html',
  styleUrls: ['./asset-risk.component.css']
})
export class AssetRiskComponent extends BaseResultComponent {
  @Input()
  assetRisk: AssetRisk;

  constructor(windowService: NbWindowService) {
    super(windowService);
  }

  onResultImpl(): void {
    super.onResultImpl();
  }
}
